/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy>): BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy(), model);
        BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy>): BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.newInstance(<BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
